import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import Breadcrumb from './Breadcrumb';
import './Layout.css';

function Layout({ children }) {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="site-wrapper">
      {/* Skip to main content link for accessibility */}
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      
      <header className="site-header" role="banner">
        <Navbar />
      </header>

      <Breadcrumb />
      
      <main id="main-content" className="site-content" role="main" tabIndex="-1">
        {children}
      </main>
      
      <Footer />
    </div>
  );
}

export default Layout;
